// Catawiki brand logomark (blue square with cut-out "C").
export const CatawikiIcon = ({ className = "" }) => (
  <svg viewBox="0 0 600 600" className={className} aria-hidden="true">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M600 0v600H0V0zM426.92 126.92H321.75c-101.23 0-183.29 80.08-183.29 178.85s82.06 178.85 183.29 178.85h105.17z"
      fill="#1B4CFF"
    />
  </svg>
);
